export enum OnboardSteps {
  Accounting,
  TeamMembers,
  SpendRules,
  IssueCards,
  ConnectBank,
}
